const $ = window.jQuery;
import plugin, { PluginBase } from "../utils/plugin";
import imagesLoaded from "imagesloaded";

class PluginClass extends PluginBase {
    constructor(el, options) {
        super(el, options);

        let $el = (this.$el = $(el));
        this.options = options;
        this.isVisible = false;

        window.lazyLoad = window.lazyLoad || {};
        window.lazyLoad.observers = window.lazyLoad.observers || {};

        this.io = this.getIntersectionObserver();

        $el = $el.filter("[data-sources],[data-src]");
        if (!$el.length) {
            this.log("element doesn't support lazyloading", el);
        }
        if (options.lazy) {
            this.$el.on("lazyload:visible", () => {
                this.isVisible = true;
                this.load();
            });
            this.$el.on("lazyload:hidden", () => {
                this.isVisible = false;
            });
            this.io.observe(el);
        } else {
            this.load();
        }
        $("body").on("mainView:render", () => this.destroy());

        return this;
    }

    maybeReload() {
        if (this.isVisible && this.$el.hasClass("lazyloaded")) {
            this.load();
            return true;
        }
        return false;
    }

    destroy() {
        super.destroy();
        if (this.io) {
            this.io.disconnect();
        }
    }

    getIntersectionObserver() {
        let observer = window.lazyLoad.observers.intersection;
        if (typeof observer !== "undefined") return observer;
        observer = new IntersectionObserver(
            (items) => {
                items.forEach((item, i) => {
                    let $el = $(item.target);
                    if (item.isIntersecting) {
                        $el.trigger("lazyload:visible");
                    } else {
                        $el.trigger("lazyload:hidden");
                    }
                });
            },
            {
                rootMargin: "100%",
                trackVisibility: true,
                delay: 100,
            },
        );
        window.lazyLoad.observers.intersection = observer;
        return observer;
    }

    onLoad(response) {
        if (this.maybeDestroy()) {
            return;
        }
        this.options.onLoad(this.$el, this, response);
    }

    load() {
        let tagName = this.$el.prop("tagName").toLowerCase();
        switch (tagName) {
            case "img":
                this.loadImage(this.$el).then((response) =>
                    this.onLoad(response),
                );
                break;
            case "image":
                this.loadSvgImage(this.$el).then((response) =>
                    this.onLoad(response),
                );
                break;

            case "iframe":
                this.loadIframe(this.$el).then((response) =>
                    this.onLoad(response),
                );
                break;

            default:
                this.loadBackgroundImage(this.$el).then((response) =>
                    this.onLoad(response),
                );
                break;
        }
    }

    /*
     * get the size of the image depending on it's ratio and the parent's size
     */
    getScaledImageWidth($img) {
        let imgRatio = $img.data("ratio");
        if (!imgRatio) {
            this.log("no ratio defined on image, falling back to 1", $img[0]);
            imgRatio = 1;
        }
        let $wrap = $img.parents(".scaled-media:first");
        if (!$wrap.length) {
            this.log("no wrapper found!", ".scaled-media:first");
            return 0;
        }
        let fitting = $wrap.data("fitting");
        let wrapWidth = $wrap.width();
        let wrapHeight = $wrap.height();
        let width = 0;

        switch (fitting) {
            // contain
            case "contain":
                width = Math.min(wrapWidth, wrapHeight * imgRatio);
                break;
            // cover
            default:
                width = Math.max(wrapWidth, wrapHeight * imgRatio);
                break;
        }
        width *= 1.2; // retina support
        return width;
    }

    loadImage($img) {
        let imgWidth = this.getScaledImageWidth($img);

        let src = $img.attr("src");
        let selectedSrc = this.selectSource($img, imgWidth);

        return new Promise((resolve, reject) => {
            if (src === selectedSrc) {
                resolve("image doesn't need loading");
            } else {
                $img.attr("src", selectedSrc);
                imagesLoaded($img.get(0), () => {
                    $img.addClass("lazyloaded");
                    resolve("image loaded");
                });
            }
        });
    }

    loadSvgImage($img) {
        let src = $img.attr("xlink:href");
        let selectedSrc = this.selectSource($img);

        return new Promise((resolve, reject) => {
            if (src === selectedSrc) {
                resolve("image doesn't need loading");
            } else {
                let img = new Image();
                img.onload = () => {
                    $img.addClass("lazyloaded");
                    resolve("svg image loaded");
                };
                img.src = selectedSrc;
                $img.attr("xlink:href", selectedSrc);
            }
        });
    }

    loadBackgroundImage($el) {
        let currentSrc = $el
            .css("background-image")
            .slice(4, -1)
            .replace(/['"]/g, "");
        let newSrc = this.selectSource($el);

        return new Promise((resolve, reject) => {
            if (currentSrc === newSrc) {
                resolve("image doesn't need loading");
            } else {
                $el.css({ backgroundImage: `url(${newSrc})` });
                imagesLoaded($el.get(0), { background: true }, () => {
                    $el.addClass("lazyloaded");
                    resolve("image loaded");
                });
            }
        });
    }

    loadIframe($el) {
        return new Promise((resolve, reject) => {
            if ($el.hasClass("lazyloaded")) {
                resolve("iframe already is loaded");
            }
            $el.attr("src", $el.data("src")).addClass("lazyloaded");
            resolve("loaded iframe");
        });
    }

    selectSource($el, width = "auto") {
        let sources = $el.data("sources");
        if (width === "auto") {
            width = this.getScaledImageWidth($el);
        }
        if (isNaN(width)) {
            this.log("couldn't calculate image size", $el[0]);
        }
        let size = "full";
        $.each(sources, (key, source) => {
            if (source[1] > width) {
                size = key;
            }
        });
        return sources[size][0];
    }

    log(msg) {
        if (this.options.debug) {
            console.log("lazyload:", msg);
        }
    }
}

PluginClass.DEFAULTS = {
    debug: false,
    lazy: true,
    onLoad: () => {},
};

plugin("lazyload", PluginClass);
